import api from "services/api";

export const fetchListQualificationNames = async () => {
  try {
    const res = await api.get("/ListQualificationName");
    return res.data;
  } catch (err) {
    throw err;
  }
};
